import { Pipe, PipeTransform } from '@angular/core';
import { TravelItemMinimalWithVisibilityMetadata } from '../../api/models/travel-item-minimal-with-visibility-metadata';
import { Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { TravelService } from '../../api/services';
import { isBefore } from 'date-fns';
import { BookingItemMinimal, TravelDraftMinimal } from '../../api/models';
import { enumBookingStatus } from '../utils/enum-booking-status';

@Pipe({
  name: 'travelMenu',
  pure: true,
})
export class TravelMenuPipe implements PipeTransform {
  gmg_editable = isBefore(new Date(), new Date(2026, 10, 30));
  selectedTravel?: TravelDraftMinimal;
  selectedBookedTravel?: BookingItemMinimal;
  constructor(
    private router: Router,
    private confirmationService: ConfirmationService,
    private travelService: TravelService,
  ) {}

  transform(
    travel:
      | TravelDraftMinimal
      | TravelItemMinimalWithVisibilityMetadata
      | BookingItemMinimal,
    confirmDelete?: Function,
    tryPublish?: Function,
    withdrawAdhesion?: Function,
  ): MenuItem[] {
    if (!('funding' in travel)) {
      // È un BOOKING
      const booking = travel as BookingItemMinimal;
      const canWithdrawAdhesion =
        !!withdrawAdhesion &&
        !!(booking.travel?.funding || booking.travel?.gmg_finalized_on) &&
        !booking.gmg_adh_confirmed &&
        (!booking.travel?.gmg_finalized_on ||
          booking.created_on < booking.travel.gmg_finalized_on) &&
        booking.status?.id !== enumBookingStatus.PENDING_REFUND &&
        booking.status?.id !== enumBookingStatus.REFUNDED;
      return [
        {
          label: 'Gestione',
          icon: 'pi pi-th-large',
          command: () => {
            this.router.navigate([
              '/viaggi-di-gruppo/travel-management-user',
              travel.identifier,
            ]);
          },
        },
        {
          label: 'Ritira adesione',
          icon: 'pi pi-undo',
          styleClass: 'red-text',
          visible: canWithdrawAdhesion,
          command: () => {
            if (withdrawAdhesion) {
              withdrawAdhesion(booking);
            }
          },
        },
        {
          label: 'Annulla prenotazione',
          icon: 'pi pi-times',
          styleClass: 'red-text',
          visible:
            !booking.travel?.funding && !booking.travel?.gmg_finalized_on,
          command: () => {
            if (confirmDelete) {
              confirmDelete(travel.id);
            }
          },
        },
      ];
    }
    //E' UN TRAVEL
    return [
      {
        label: 'Modifica',
        icon: 'pi pi-pencil',
        visible:
          !travel.draft &&
          travel.funding &&
          this.gmg_editable &&
          !travel.gmg_finalized_on,
        command: () => {
          this.router.navigate([
            '/viaggi-di-gruppo/edit-travel-gmg',
            travel.id,
          ]);
        },
      },
      {
        label: 'Finalizza',
        icon: 'pi pi-check',
        visible: !travel.draft && travel.funding && this.gmg_editable,
        command: () => {
          this.confirmationService.confirm({
            header: 'Finalizza viaggio GMG',
            message:
              'Stai per compiere l’ultimo passo verso la realizzazione del tuo evento GMG. Confermando, potrai inserire tutti i dettagli necessari per completarne la configurazione e ricevere conferme o nuove prenotazioni.\n\nDa questo momento avrai fino a 2 ore per finalizzare l’evento. Durante questa breve finestra, le adesioni e le donazioni saranno temporaneamente sospese, così da permetterti di lavorare in tutta tranquillità.\n\nUna volta concluso il processo, l’evento GMG tornerà online e sarà nuovamente disponibile per l’acquisto.',
            acceptLabel: 'Finalizza',
            rejectLabel: 'Indietro',
            acceptButtonStyleClass: 'bg-dialog p-button-sm',
            rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
            accept: () => {
              this.travelService
                .travelControllerMarkAsFinalizing({ id: travel.id! })
                .subscribe({
                  next: (res) => {
                    this.router.navigate([
                      '/viaggi-di-gruppo/edit-draft',
                      res.data!.id,
                    ]);
                  },
                });
            },
          });
        },
      },
      {
        label: 'Modifica',
        icon: 'pi pi-pencil',
        visible: !travel.draft && !travel.funding && !travel.gmg_finalized_on,
        command: () => {
          this.router.navigate(['/viaggi-di-gruppo/edit-travel', travel.id]);
        },
      },
      {
        label: 'Modifica',
        icon: 'pi pi-pencil',
        visible:
          travel.draft &&
          (!travel.funding || !!travel.gmg_finalizing) &&
          !travel.gmg_finalized_on,
        command: () => {
          this.router.navigate(['/viaggi-di-gruppo/edit-draft', travel.id]);
        },
      },
      {
        label: 'Modifica',
        icon: 'pi pi-pencil',
        visible:
          travel.draft &&
          travel.funding &&
          !travel.gmg_finalizing &&
          !travel.gmg_finalized_on,
        command: () => {
          this.router.navigate(['/viaggi-di-gruppo/edit-draft-gmg', travel.id]);
        },
      },
      {
        label: 'Gestione',
        icon: 'pi pi-th-large',
        visible: !travel.draft,
        command: () => {
          this.router.navigate([
            '/viaggi-di-gruppo/travel-management',
            travel.id,
          ]);
        },
      },
      {
        label: 'Pubblica',
        icon: 'pi pi-eye',
        visible: travel.draft && !!tryPublish,
        command: () => {
          if (tryPublish) {
            tryPublish(travel.id, travel);
          }
        },
      },
      {
        label: 'Invita',
        icon: 'pi pi-address-book',
        visible:
          !travel.draft && (travel.funding || travel.visibility?.id === 2),

        command: () => {
          this.router.navigate(['/user/address-book']);
        },
      },

      {
        label: 'Elimina',
        icon: 'pi pi-times',
        styleClass: 'red-text',
        visible: !!confirmDelete,
        command: () => {
          if (confirmDelete) {
            confirmDelete(travel.id);
          }
        },
      },
    ];
  }
}
